module.exports = __webpack_public_path__ + "img/banner_img_0008.aabb7ee8.jpg";